// import React, { useState, useEffect } from 'react';
// import styles from './UserManagement.module.css';

// const UserHistoryModal = ({ show, user, onClose, onFetchHistory }) => {
//     const [userHistory, setUserHistory] = useState([]);

//     useEffect(() => {
//         if (show && user) {
//             loadHistory();
//         }
//     }, [show, user]);

//     const loadHistory = async () => {
//         const history = await onFetchHistory(user.user_id);
//         setUserHistory(history);
//     };

//     if (!show || !user) return null;

//     return (
//         <div className={styles.modalOverlay} onClick={onClose}>
//             <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
//                 <div className={styles.modalHeader}>
//                     <h2 className={styles.modalTitle}>User Activity History</h2>
//                     <button className={styles.modalClose} onClick={onClose}>×</button>
//                 </div>
//                 <div className={styles.modalBody}>
//                     <p><strong>User:</strong> {user.full_name}</p>
//                     <div className={styles.historyContent}>
//                         {userHistory.length === 0 ? (
//                             <p className={styles.noHistory}>No history available</p>
//                         ) : (
//                             <div className={styles.historyList}>
//                                 {userHistory.map((item) => (
//                                     <div key={item.audit_id} className={styles.historyItem}>
//                                         <div className={styles.historyHeader}>
//                                             <span className={styles.historyAction}>{item.action_type}</span>
//                                             <span className={styles.historyDate}>{new Date(item.timestamp).toLocaleString()}</span>
//                                         </div>
//                                         <div className={styles.historyDetails}>
//                                             <p><strong>Module:</strong> {item.module_name}</p>
//                                             <p><strong>Performed by:</strong> {item.performed_by || 'System'}</p>
//                                             <p><strong>IP Address:</strong> {item.ip_address}</p>
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         )}
//                     </div>
//                 </div>
//                 <div className={styles.modalFooter}>
//                     <button className={styles.cancelButton} onClick={onClose}>Close</button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default UserHistoryModal;

import React, { useState, useEffect } from 'react';
import styles from './UserManagement.module.css';

const UserHistoryModal = ({ show, user, onClose, onFetchHistory }) => {
    const [userHistory, setUserHistory] = useState([]);

    useEffect(() => {
        if (show && user) {
            loadHistory();
        }
    }, [show, user]);

    const loadHistory = async () => {
        const history = await onFetchHistory(user.user_id);
        setUserHistory(history);
    };

    if (!show || !user) return null;

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <h2 className={styles.modalTitle}>User Activity History</h2>
                    <button className={styles.modalClose} onClick={onClose}>×</button>
                </div>
                <div className={styles.modalBody}>
                    <p><strong>User:</strong> {user.full_name}</p>
                    <div className={styles.historyContent}>
                        {userHistory.length === 0 ? (
                            <p className={styles.noHistory}>No history available</p>
                        ) : (
                            <div className={styles.historyList}>
                                {userHistory.map((item) => (
                                    <div key={item.audit_id} className={styles.historyItem}>
                                        <div className={styles.historyHeader}>
                                            <span className={styles.historyAction}>{item.action_type}</span>
                                            <span className={styles.historyDate}>{new Date(item.timestamp).toLocaleString()}</span>
                                        </div>
                                        <div className={styles.historyDetails}>
                                            <p><strong>Module:</strong> {item.module_name}</p>
                                            <p><strong>Performed by:</strong> {item.performed_by || 'System'}</p>
                                            <p><strong>IP Address:</strong> {item.ip_address}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.modalFooter}>
                    <button className={styles.cancelButton} onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default UserHistoryModal;